function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { useRef, useState } from "react";
import { useDrag } from "@use-gesture/react";
import Popover from "../popover";
var classPrefix = "tc-slider";
var Thumb = function Thumb(props) {
  var value = props.value,
    max = props.max,
    min = props.min,
    disabled = props.disabled,
    icon = props.icon,
    residentPopover = props.residentPopover,
    onDrag = props.onDrag,
    popover = props.popover,
    trackRef = props.trackRef;
  var preValue = useRef(value);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dragging = _useState2[0],
    setDragging = _useState2[1];
  var currentPosition = function currentPosition() {
    return {
      left: "".concat((value - min) / (max - min) * 100, "%"),
      right: "auto"
    };
  };
  var bind = useDrag(function (state) {
    var _a;
    if (disabled) return;
    if (state.first) {
      preValue.current = value;
    }
    var x = state.xy[0] - state.initial[0];
    var sliderOffsetWidth = (_a = trackRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
    if (!sliderOffsetWidth) return;
    var diff = x / Math.ceil(sliderOffsetWidth) * (max - min);
    onDrag(preValue.current + diff, state.first, state.last);
    setDragging(!state.last);
  }, {
    axis: "x",
    pointer: {
      touch: true
    }
  });
  var renderPopoverContent = typeof popover === "function" ? popover : popover ? function (v) {
    return v.toString();
  } : null;
  var thumbElement = icon !== null && icon !== void 0 ? icon : /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-thumb")
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: "".concat(classPrefix, "-thumb-container"),
    style: currentPosition()
  }, bind(), {
    role: 'slider',
    "aria-label": props["aria-label"],
    "aria-valuemax": max,
    "aria-valuemin": min,
    "aria-valuenow": value,
    "aria-disabled": disabled
  }), renderPopoverContent ? /*#__PURE__*/React.createElement("div", {
    className: "popover"
  }, /*#__PURE__*/React.createElement(Popover, {
    content: renderPopoverContent(value),
    placement: 'top',
    visible: residentPopover || dragging,
    getContainer: null,
    mode: 'dark'
  }, thumbElement)) : thumbElement);
};
export default Thumb;